<template>
  <div class="reportManage">
    <a-form layout="inline" class="form-flex">
      <!-- <a-form-item :label="$tc('lang.Reports.sys_nr')">
        <a-input
          v-model="dataForm.productOrderId"
          :placeholder="$tc('lang.Reports.sys_nr')"
        >
        </a-input>
      </a-form-item> -->
      <a-form-item :label="$tc('lang.Reports.Service_Date')">
        <a-range-picker
        style="width: 200px;"
          v-model="dataForm.time"
          :placeholder="[
            $tc('lang.Reports.Start_from'),
            $tc('lang.Reports.End'),
          ]"
        />
      </a-form-item>
      <a-form-item :label="$tc('lang.orderAll.Factory_sel')" >
        <a-input
        style="width: 100px;"
          v-model="dataForm.factoryName"
          :placeholder="$tc('lang.orderAll.Factory_sel')"
        >
        </a-input>
      </a-form-item>
      
      <a-form-item :label="$tc('lang.orderAll.PO_Number')">
        <a-input
        style="width: 100px;"
          v-model="dataForm.productOrderId"
          :placeholder="$tc('lang.orderAll.PO_Number')"
        >
        </a-input>
      </a-form-item>
     
      <a-form-item :label="$tc('lang.orderAll.Product_Name')">
        <a-input
        style="width: 100px;"
          v-model="dataForm.proName"
          :placeholder="$tc('lang.orderAll.Product_Name')"
        >
        </a-input>
      </a-form-item>
      <a-form-item :label="$tc('lang.orderAll.Item_Number')">
        <a-input
        style="width: 100px;"
                   v-model="dataForm.proModelid"
          :placeholder="$tc('lang.orderAll.Item_Number')"
        >
        </a-input>
      </a-form-item>
      

      <a-form-item>
        <a-button type="primary" html-type="submit" @click="handleSubmit">
          {{ $tc('lang.orderAll.Serach') }}
        </a-button>
      </a-form-item>
    </a-form>
    <a-table
      :columns="columns"
      :dataSource="data"
      :scroll="{ x: width1, y: 'calc(150vh - 560px)' }"
      :locale="{
        emptyText: $tc('lang.No_data'),
      }"
      style="
         width: 97%;
         margin: 20px;
        border: 1px solid #dbdbdb"
      :loading="loading"
      rowKey="reportNo"
      :pagination="{
        total: total,
        current: page,
        pageSize: size,
        onChange: onChangePage,
      }"
    >
      <span slot="planTime" slot-scope="text, record">{{
        $momentData(record.planTime)
      }}</span>
      <span slot="action" slot-scope="record">
        <!-- <a-button-group>
          <a-button
            type="primary"
            title="查看"
            @click="lookReport(record)"
            size="small"
            >{{ $tc('lang.orderAll.View') }}</a-button
          >
        </a-button-group> -->
        &nbsp;&nbsp;
        <a-button-group>
          <a-button
            type="primary"
            :title="$tc('lang.myHome.Download')"
            style="
        display: inline-block;
        margin-right: 5px;
        background: #FF8D1A;
        border: 1px solid #FF8D1A"
            @click="downloadReport(record)"
            :disabled="!record.pdfPath"
            size="small"
            >{{ $tc('lang.myHome.Download') }}</a-button
          >
        </a-button-group>
      </span>
    </a-table>
  </div>
</template>
<script>
// const columns = ;
export default {
  data() {
    return {
      data: [],
      columns: [
        {
          title: this.$tc('lang.Reports.Nr'),
          align: 'center',
          width: 60,
          key: 'center',
          fixed: 'left',
          customRender: (text, record, index) => `${index + 1}`,
        },
        {
          title: this.$tc('lang.Reports.Service_Date'),
          key: 'planTime',
          dataIndex: 'planTime',
          width: 120,
          align: 'center',
          scopedSlots: { customRender: 'planTime' },
        },
        {
          title: this.$tc('lang.Reports.Factory'),
          key: 'factoryName',
          dataIndex: 'factoryName',
          width: 150,
          align: 'center',
        },
        {
          title: this.$tc('lang.Reports.Order_Nr'),
          dataIndex: 'productOrderId',
          key: 'productOrderId',
          width: 180,
          align: 'center',
        },
        
        {
          title: this.$tc('lang.LoadingReport.Product_Name'),
          dataIndex: 'proName',
          key: 'proName',
          width: 150,
          align: 'center',
        },
        {
          title: this.$tc('lang.LoadingReport.Item_Number'),
          dataIndex: 'proModelid',
          key: 'proModelid',
          width: 200,
          align: 'center',
          // customRender: text => {
          //   if (text == '轻工产品类') {
          //     return this.$tc('lang.Category.Groceries');
          //   } else if (text == '电子电器类') {
          //     return this.$tc('lang.Category.Electronics');
          //   } else if (text == '面料纺织品类') {
          //     return this.$tc('lang.Category.Fabric');
          //   } else if (text == '服装服饰类') {
          //     return this.$tc('lang.Category.Garment');
          //   } else {
          //     return text;
          //   }
          // },
        },
       
       
        {
          title: this.$tc('lang.Reports.Total_MD'),
          key: 'dayTime',
          dataIndex: 'dayTime',
          width: 120,
          align: 'center',
        },
        // {
        //   title: this.$tc('lang.Reports.Order_Nr'),
        //   key: 'orderNo',
        //   dataIndex: 'orderNo',
        //   width: 180,
        //   align: 'center',
        // },
        // {
        //   title: this.$tc('lang.Reports.Report'),
        //   key: 'action',
        //   scopedSlots: { customRender: 'action' },
        //   width: 230,
        //   align: 'center',
        // },
        {
          title: this.$tc('lang.orderAll.Operate'),
          key: 'action',
          width: 180,
          scopedSlots: { customRender: 'action' },
          // width: '14%',
          fixed: 'right',
          align: 'center',
          visible: false,
          condition: true,
        },
      ],
      dataForm: {
        reportNo: null,
        orderNo: null,
        productOrderId:null,
        factoryName:null,
          proName:null,
          proModelid:null,
        time: [],
      },
      page: 1,
      size: 10,
      total: 0,
      loading: false,
      orderIdSt: '',
      width1: 0,
    };
  },
  created() {
    // 获取页面路径信息
    const url = window.location.href;
    const theRequest = new Object();
    // 取是否以问号(?)为下标如果有者返回该值的下标，如果没有就返回-1
    if (url.indexOf('?') != -1) {
      //截取字符串 以问号(?)开始在进行加1前进一个的下标，以那个下标为准开始截取
      const str = url.substr(url.indexOf('?') + 1);
      const strs = str.split('&');
      for (let i = 0; i < strs.length; i++) {
        theRequest[strs[i].split('=')[0]] = strs[i].split('=')[1];
      }
      // return theRequest;
    }
    console.log('theRequest', theRequest);
    this.orderIdSt = theRequest.id;
    this.dataList();
    this.width();
  },
  methods: {
    width() {
      for (let i = 0; i < this.columns.length; i++) {
        this.width1 += this.columns[i].width;
      }
    },

    // 获取列表
    dataList() {
      this.loading = true;
      const userData = JSON.parse(sessionStorage.getItem('user')) || {};
      console.log('=======22====', this.dataForm);
      this.$http
        .post('/hzwmj/workorder-inspectreport/getPageList', {
          reportNo: this.dataForm.reportNo,
          factoryName: this.dataForm.factoryName,
          proName: this.dataForm.proName,
          proModelid: this.dataForm.proModelid,
          productOrderId:this.dataForm.productOrderId,
          orderNo:
            this.dataForm.orderNo === null
              ? this.orderIdSt
              : this.dataForm.orderNo,
          startTime:
            this.dataForm.time.length == 0
              ? ''
              : this.dataForm.time[0].format('YYYY-MM-DD'),
          endTime:
            this.dataForm.time.length == 0
              ? ''
              : this.dataForm.time[1].format('YYYY-MM-DD'),
          page: this.page,
          size: this.size,
          personId: userData.id,
        })
        .then(data => {
          if (data != null) {
            const reastData = data.data;
            this.data = reastData.records;
            this.total = reastData.total;
            if (this.dataForm.orderNo !== null) {
              this.$router.push({
                path: '/reportManage',
                query: {},
              });
            }
            this.loading = false;
          } else {
            this.data = [];
            this.total = 0;
            this.loading = false;
          }
        })
        .catch(() => {
          this.data = [];
          this.total = 0;
          this.loading = false;
        });
    },
    onChangePage(page) {
      this.page = page;
      this.dataList();
    },
    handleSubmit() {
      this.page = 1;
      this.dataList();
    },

    action(record) {
      console.log(record);
      this.$router.push({
        path: '/client/clientDetails',
        query: {
          key: record.key,
        },
      });
    },
    // 查看报告
    lookReport(record) {
      if (record.orderType == 5) {
        this.$router.push({
          path: '/reportManage/supervisionReportBasic',
          query: {
            id: record.id,
          },
        });
      } else if (record.orderType == 3) {
        this.$router.push({
          path: '/reportManage/fabricReportBasic',
          query: {
            id: record.id,
          },
        });
      } else if (record.orderType == 4) {
        this.$router.push({
          path: '/reportManage/factoryReportBasic',
          query: {
            id: record.id,
          },
        });
      } else {
        this.$router.push({
          path: '/reportManage/reportBasic',
          query: {
            id: record.id,
          },
        });
      }
    },
    // 报告下载
    downloadReport(record) {
      // const hide = this.$message.loading('报告生成中...', 0);
      // setTimeout(hide, 0);
      let aLink = document.createElement('a');
      document.body.appendChild(aLink);
      aLink.target = '_blank';
      aLink.href = this.config.urlImg + record.pdfPath;
      aLink.click();
      // this.$http
      //   .get('/hzwmj/workorder-inspectreport/creatReport', {
      //     params: {
      //       orderId: record.orderNo,
      //       reportId: record.reportNo,
      //     },
      //   })
      //   .then(data => {
      //     if (data) {
      //       // setTimeout(hide, 0);
      //       // var aLink = document.createElement('a');
      //       // aLink.download = 'demo';
      //       // aLink.href = this.config.urlImg + data.data;
      //       // aLink.click();
      //       setTimeout(hide, 0);
      //       let aLink = document.createElement('a');
      //       document.body.appendChild(aLink);
      //       aLink.href = this.config.urlImg + data;
      //       aLink.click();
      //       aLink.remove();
      //     } else {
      //       setTimeout(hide, 0);
      //       this.$message.error('生成失败');
      //     }
      //   })
      //   .catch(() => {
      //     setTimeout(hide, 0);
      //     this.$message.error('生成失败');
      //   });
    },
  },
};
</script>
<style lang="less">
.reportManage {
  padding-top: 10px;
  padding-bottom: 40px;
  border-left: 3px solid #f0f2f5;
  border-right: 2px solid #f0f2f5;
  border-bottom: 2px solid #a7a7a7;
  border-radius: 10px;
  margin-top: 3%;
  .form-flex {
    border-radius: 10px;
    border-bottom: 2px solid #a2a2a2;
    border-left: 1px solid #dbdbdb;
    border-right: 1px solid #dbdbdb;
    width: 97%;
    margin: 20px;
  }
}
</style>
